import { RestCRUDService } from '../../../../../service/common/rest/RestCRUDService';
import { IRiskManagerQuestionAnswerPresetModel } from './IRiskManagerQuestionAnswerPresetModel';
import { IRiskManagerQuestionAnswerPresetSearch } from './IRiskManagerQuestionAnswerPresetSearch';
import { IRiskManagerQuestionAnswerPresetService } from './IRiskManagerQuestionService';

export class RestRiskManagerQuestionAnswerPresetService
  extends RestCRUDService<IRiskManagerQuestionAnswerPresetModel, IRiskManagerQuestionAnswerPresetSearch>
  implements IRiskManagerQuestionAnswerPresetService
{
  constructor(private type: 'admin' | 'public') {
    super();
  }

  getEndpoint(): string {
    const url = this.type === 'admin' ? this.config.url.api.admin : this.config.url.api.public;
    return `${url}/extension/risk/manager/question/answer/preset`;
  }
}
